// src/ProductList.jsx
import React from "react";
import ProductItem from "./ProductItem";

/**
 * Container component for product list in planner
 */
const ProductList = ({
  productNodes,
  selectProductNodeInstance,
  removeProductNodeInstance,
  duplicateProductNode,
  rotateProductNodeInstance,
  changeProductNodeInstanceHeight,
  applyMaterial,
  labels,
  selectedProductLocalId,
  onSelectProduct,
}) => {
  // If no products, show message
  if (Object.keys(productNodes).length === 0) {
    return (
      <div className="ay-text-center ay-text-gray-500 ay-py-8">
        <p>{labels.noProducts}</p>
      </div>
    );
  }

  const [internalSelectedId, setInternalSelectedId] = React.useState(null);

  const activeId =
    selectedProductLocalId !== undefined
      ? selectedProductLocalId
      : internalSelectedId;

  const handleToggle = (id) => {
    const newId = activeId === id ? null : id;
    if (onSelectProduct) {
      onSelectProduct(newId);
    } else {
      setInternalSelectedId(newId);
      // For legacy behavior (Planner copy.js), also trigger selection in viewer if expanding
      if (newId && selectProductNodeInstance) {
        selectProductNodeInstance(productNodes[newId])();
      }
    }
  };

  return (
    <div className="ay-space-y-4">
      {Object.values(productNodes).map((pn) => (
        <ProductItem
          key={pn.localId}
          pn={pn}
          selectProductNodeInstance={selectProductNodeInstance}
          removeProductNodeInstance={removeProductNodeInstance}
          duplicateProductNode={duplicateProductNode}
          rotateProductNodeInstance={rotateProductNodeInstance}
          changeProductNodeInstanceHeight={changeProductNodeInstanceHeight}
          applyMaterial={applyMaterial}
          labels={labels}
          isExpanded={activeId === pn.localId}
          onToggle={() => handleToggle(pn.localId)}
        />
      ))}
    </div>
  );
};

export default ProductList;
